module.exports = __webpack_public_path__ + "img/9788989456216.b99de0be.jpg";